import { apiClient, type CustomerContractExEntity } from '@/libs/api'

export type FetchCustomerContractQuery = {
  tenantKey: string
  customerContractId: number
}

export const fetchCustomerContract = async (
  { tenantKey, customerContractId }: FetchCustomerContractQuery,
  signal?: AbortSignal
): Promise<CustomerContractExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .customer_contracts._id(customerContractId)
    .$get({
      config: { signal }
    })
  return data
}
